import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Hero3 from '../../components/hero3/hero3'
import CaseStudyHero from '../../components/hero3/casestudyhero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import casestudy from '../../images/casestudy.png'
import { Link } from 'react-router-dom'

const BlogList = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <CaseStudyHero top_title={<>Your Shortcut to, <br/> Everything</>} top_desp={<>A collection of powerful productivity tools all within an <br/> extendable launcher. Fast, ergonomic and reliable.</>} />

                    <section className="intro_about_section section_space">
                        <div className="container">
                             
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                        <Row>
                                            <Col sm={3}>
                                                <div className="megamenu_pages_wrapper">
                                                    <h3 className="megamenu_info_title mb-0">Select Category</h3>
                                                </div>
                                                <Nav variant="pills" className="flex-column casestudy_nav" >
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first">All</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second">Software Development</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="thired">Mobile App</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="fourth">Web App</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="fifth">Modernization</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="sixth">DevOps</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={9} style={{paddingTop:'0px'}}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div className='row' style={{margin:'0px'}}>
                                                            <div className='col-lg-6'>
                                                                <div className='blog_study_item'>
                                                                    <div className='blog_img'>
                                                                        <img src={casestudy} alt='casestudy' />
                                                                    </div>
                                                                    <p className='blog_cat'>Category</p>
                                                                    <h3 className='blog_title'>Case Study Title</h3>
                                                                    <ul className='blog_meta'>
                                                                        <li className='blog_author'><i class="fa fa-user" aria-hidden="true"></i>&nbsp;&nbsp;by Admin</li>
                                                                        <li className='blog_date'><i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;&nbsp;August 20, 2024</li>
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                            <div className='col-lg-6'>
                                                                <div className='blog_study_item'>
                                                                    <div className='blog_img'>
                                                                        <img src={casestudy} alt='casestudy' />
                                                                    </div>
                                                                    <p className='blog_cat'>Category</p>
                                                                    <h3 className='blog_title'>Case Study Title</h3>
                                                                    <ul className='blog_meta'>
                                                                        <li className='blog_author'><i class="fa fa-user" aria-hidden="true"></i>&nbsp;&nbsp;by Admin</li>
                                                                        <li className='blog_date'><i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;&nbsp;August 20, 2024</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                
                        </div>
                    </section>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default BlogList;
